module.exports = function() {
  return new Worker(__webpack_public_path__ + "34fffba8d295ff0d6453.worker.js");
};